import React, { useState, useEffect } from 'react';
import apis from '../../../common-ask/apis';

function CommonAsk() {
  const [questionListInfo, setQuestionListInfo] = useState([]);

  useEffect(() => {
    const conditions = {
      source: 'client',
      showChild: 1,
      parentId: -1,
    };
    apis
      .HelpListCategory(conditions)
      .then((res) => {
        if (res && res.ret === '0') {
          const commonAsk = res.data.list.filter((item) => item.name === '常见问题');
          const docQuestion = commonAsk[0].childList && commonAsk[0].childList.filter((item) => item.type === 2);
          setQuestionListInfo(docQuestion[0]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function toHelpCenterCommonQuestion(item) {
    const { id = '', type = '', categoryIds = '', firstDocId = '', firstDocCategoryIds = '' } = item;
    const url =
      firstDocId && firstDocCategoryIds
        ? `/help/list/${id}?type=${type}&categoryIds=${categoryIds}&firstDocId=${firstDocId}&firstDocCategoryIds=${firstDocCategoryIds}`
        : `/help/list/${id}?type=${type}&categoryIds=${categoryIds}`;
    window.open(url);
  }

  return (
    <span
      className="help_center__title ellipsis-1-line"
      clstag="yx_center|workbench_sidequestionclick"
      onClick={() => toHelpCenterCommonQuestion(questionListInfo)}
    >
      {questionListInfo.name}
    </span>
  );
}

export default CommonAsk;
